// experience-backend has no equivalent of the old Firestore causeTypes
// collection (archiving, translations, per-org cause type catalog), so this
// is an honest stub. It doesn't throw, so callers that just want a "best
// effort" archive don't crash, but nothing is actually persisted.
export const CauseTypeService = {
  async addCauseType(_causeType: Record<string, unknown>): Promise<{ id: string } | null> {
    console.warn(
      "CauseTypeService.addCauseType: not supported by experience-backend yet."
    );
    return null;
  },

  async archiveCauseType(_id: string, _organizationId?: string): Promise<void> {
    console.warn(
      "CauseTypeService.archiveCauseType: not supported by experience-backend yet."
    );
  },
};
